import type {ValueOf} from '~/types/value-of'

export const INftType = {
  ERC721: 'ERC721',
  ERC1155: 'ERC1155',
} as const
export type INftType = ValueOf<typeof INftType>;

export const ITokenType = {
  ...INftType,
  ERC20: 'ERC20',
  NATIVE: 'NATIVE',
} as const
export type ITokenType = ValueOf<typeof ITokenType>;